import Button from "devextreme-react/button";
import { useContext, useState } from "react";
import { RetailOrderContext } from "../context/RetailOrderContext";
import { apiGenerateRetailOrderReport } from "../../../common/retail-order-report/api/get-retail-order-report";
import { Buffer } from 'buffer';
import { showErrorMessage } from "../../../../utils/messages";
import { RetailOrderReportType } from "../../../common/retail-order-report/type/RetailOrderReportType";
import { LoadPagePanel } from "../../../../components";

export default function PrintButton(props: { reportType: RetailOrderReportType }) {

	const { order } = useContext(RetailOrderContext);

	let [loading, setLoading] = useState(false);

	return (
		<>
			<Button
				elementAttr={{ 'data-testid': 'btn-print' }}
				text="Print"
				icon="Inscyth-Print"
				onClick={() => {
					setLoading(true);

					apiGenerateRetailOrderReport(order.details.retailOrderID, props.reportType)
						.then((result) => {
							if (result.isSuccess) {
								const file = new Blob(
									[Buffer.from(result.data, "base64")],
									{ type: 'application/pdf' });

								const fileURL = URL.createObjectURL(file);
								window.open(fileURL);
							}
							else {
								showErrorMessage(result.errorMessage!);
							}
						})
						.catch((reason) => {
							showErrorMessage(reason);
						})
						.finally(() => { setLoading(false); });
				}}>
			</Button>
			<LoadPagePanel visible={loading} />
		</>
	)
}
